import { useState } from "react";

const MaterialTabbar = ({ onTabChange }) => {
  const [activeTab, setActiveTab] = useState("Active");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  return (
    <div className="flex items-center">
      <span
        onClick={() => handleTabClick("Active")}
        className={`cursor-pointer font-OpenSansRegular text-[14px] font-[600] px-4 ${
          activeTab === "Active" ? "text-blueColor" : "text-subTitleColor"
        }`}
      >
        Active
      </span>
      <div className="h-4 w-[1px] bg-borderColor"></div>
      <span
        onClick={() => handleTabClick("Archived")}
        className={`cursor-pointer font-OpenSansRegular text-[14px] font-[600] px-4 ${
          activeTab === "Archived" ? "text-blueColor" : "text-subTitleColor"
        }`}
      >
        Archived
      </span>
    </div>
  );
};

export default MaterialTabbar;
